export default __webpack_public_path__ + "5d14ee2bcf122bf67f1354c68137b39f.png";